module.exports = __webpack_public_path__ + "media/images/icon_list/place_holder-1fae6e38521a85a5cd56720f8b0d733a.svg";